import { Inject, Injectable, Injector }from '@angular/core';

import { LocusRobotics_DatasourceService } from './LocusRobotics.datasource.index';


@Injectable({ providedIn: 'root' })
export class app_DatasourceService {

  constructor(
    private injector: Injector
  ) {
    this.LocusRobotics = this.injector.get(LocusRobotics_DatasourceService);
  }

    public LocusRobotics: LocusRobotics_DatasourceService;
  public app: app_DatasourceService = this;

  // injecting lazily in order to avoid circular dependencies
}

